import { Component, ViewChild, ElementRef } from '@angular/core';
// importing the superclass
import { Module } from './../module.component';
// services
import { Status } from './../../service/status.service';
import { SupplyDocService } from './supply-doc.service';
// models

// component definition
@Component({
  selector: 'app-supply-doc',
  templateUrl: './supply-doc.component.html',
  providers:
  [
    SupplyDocService
  ]
})
export class SupplyDocComponent extends Module {

	globalExpansion = false;

	constructor(private supDocService:                  SupplyDocService,
				private status:                         Status) {
		super();
		this.setBindExposer(this.status.getExposer());
		this.getExposer().getModelsManager().supply_doc_request;

		this.setFormEnable(this.getCustomizingService().getBoolean('SUPPLIER.DOCS.LIST.FORM.ENABLE', false));
		this.setAutoSearchEnable(this.getCustomizingService().getBoolean('SUPPLIER.DOCS.LIST.AUTOSEARCH.ENABLE', false));

		this.requestModelSetUp();
		if(this.getAutoSearchEnable()){
		  this.doSearch();
		}
  }

  // set up the request model
  requestModelSetUp() {
    this.getModelsManager().supply_doc_request.supplier_code = this.getAccountService().supplierProperties.supplier_code;
    this.getModelsManager().supply_doc_request.company_code = this.getAccountService().getUserCompany().code;
    this.getModelsManager().supply_doc_request.language = this.getLocale().getPreferredLanguage();
  }

  // send the query to the server
  doSearch() {
    this.supDocService.searchDocs();
    this.showSearchParameters = false;
  }

  // return true if service is stil searching
  isServiceSearching() {
    return this.supDocService.isSearching();
  }

  // returns the status of the server query
  isResultEmpty() {
    return this.supDocService.getDocs().length === 0;
  }

  // clear the input values
  clearFormValues() {
    this.requestModelSetUp();
  }

  // get the response from supply document model
  getSupplyDocServiceResponse() {
    return this.getOrderedList(this.supDocService.getDocs(), this.sortType, this.sortReverse);
  }

  // returns normalized date
  getNormalDate(value) {
    if (value !== null && value !== undefined) {
      const date = new Date(value);
      this.getDateTimeManager().setDate(date);
      const text = this.getDateTimeManager().ddmmyyyy('/');
      return text;
    } else {
      return '';
    }
  }

  downloadDocument(docType, docNumber, docVersion, docPart, filePath, fileName) {
    this.supDocService.downloadDocument(docType, docNumber, docVersion, docPart, filePath, fileName);
  }

  getSplit(file, part) {
    return file.file_name.split(".")[part];
  }

	// Menage expansion state of table row
	switchGlobalExpansion() {
		this.globalExpansion = !this.globalExpansion;
		for (const element of this.getSupplyDocServiceResponse()) {
			element.expanded = this.globalExpansion;
		}
  }
	

}



// WEBPACK FOOTER //
// ./src/app/components/supply-doc/supply-doc.component.ts